import { ImageItem } from 'src/app/ui/components/select-simple-list/model/item-image.interface';
import { ProfilesEnum } from '../models/enum/profiles.enum';
import { Profile } from '../models/interfaces/profile.interface';

export const ProfilesNameSeparetedByComma = (
  profiles: Profile[],
  idsProfiles: string[]
): string => {
  let profilesName = '';
  profiles.forEach((profile) => {
    if (idsProfiles.includes(profile.id!)) {
      if (profilesName == '') {
        profilesName = profile.name.trim();
      } else {
        profilesName = profilesName + ', ' + profile.name.trim();
      }
    }
  });
  return profilesName;
};

export const formatSelectedProfilesText = (profiles: ImageItem[]): string => {
  const countCheckedProfiles = profiles.filter(
    (profile) => profile.isChecked
  ).length;
  let profilesText = '';
  if (countCheckedProfiles >= 1) {
    profilesText = profiles.filter((profile) => profile.isChecked)[0].name;
    if (countCheckedProfiles > 1) {
      profilesText = profilesText
        .concat(' +')
        .concat((countCheckedProfiles - 1).toString());
    }
  }
  return profilesText;
};

export const RESTRICTED_ROUTE_PROFILES = (
  allowedProfiles: ProfilesEnum[],
): ProfilesEnum[] => [
  ...new Set([
    ...ADMIN_ACCESS_PROFILES,
    ...allowedProfiles,
  ]),
];

export const ALL_PROFILES = Object.values(ProfilesEnum);

export const ADMIN_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.ADMIN,
  ProfilesEnum.SUPORTE,
];

export const DIRECTOR_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.DIRETOR,
]

export const MANAGEMENT_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.COORDENADOR,
  ProfilesEnum.DIRETOR,
];

export const EMPLOYEE_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.FUNCIONARIO,
];

export const TEACHER_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.PROFESSOR,
];

export const ADVISOR_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.ASSESSOR,
];

export const RESPONSABLE_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.RESP_FINANCEIRO,
  ProfilesEnum.RESP_FINANCEIRO_PEDAGOGICO,
  ProfilesEnum.RESP_PADAGOGICO,
];

export const STUDENT_PROFILES: ProfilesEnum[] = [
  ProfilesEnum.ALUNO
]

export const COORDINATOR_PROFILES = [
  ProfilesEnum.COORDENADOR,
];

export const ADMIN_ACCESS_PROFILES: ProfilesEnum[] = [
  ...ADMIN_PROFILES,
];

export const EMPLOYEES_PROFILES: ProfilesEnum[] = [
  ...MANAGEMENT_PROFILES,
  ...EMPLOYEE_PROFILES,
];

export const MANAGEMENT_ADVISOR_PROFILES: ProfilesEnum[] = [
  ...MANAGEMENT_PROFILES,
  ...ADVISOR_PROFILES,
];

export const BUSINESS_PROFILES: ProfilesEnum[] = [
  ...MANAGEMENT_PROFILES,
  ...EMPLOYEE_PROFILES,
  ...ADVISOR_PROFILES,
];

export const ExcludeProfessorAndEmployees = [
  ProfilesEnum.ADMIN,
  ProfilesEnum.SUPORTE,
  ProfilesEnum.COORDENADOR,
  ProfilesEnum.DIRETOR,
  ProfilesEnum.FUNCIONARIO,
  ProfilesEnum.PROFESSOR,
  ProfilesEnum.ASSESSOR,
];
